import { render } from "./SeguradoCadastro.vue?vue&type=template&id=7c5ec422&scoped=true&ts=true"
import script from "./SeguradoCadastro.vue?vue&type=script&lang=ts"
export * from "./SeguradoCadastro.vue?vue&type=script&lang=ts"

import "./SeguradoCadastro.vue?vue&type=style&index=0&id=7c5ec422&lang=css&scoped=true"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5ec422"]])

export default __exports__